<template>
	<div class="home_wrap">
		<div class="backgroud_bg">
			<img src="../images/index/res-bg.png" alt="" style="width: 100%;">
		</div>
		<div class="bengin_act">
			<div class="backgroud_bg">
				<img src="../images/index/res-bg-1.png" alt="" style="width: 100%;">
			</div>
			<div class="content_box" v-show="contentBox1">
				<div class="alert_box">
					<div class="alert_header">
						<img src="../images/index/ryh.png" alt="" style="width: 100%;">
					</div>
					<div class="alert_content">
						<div class="content_img" v-show="showBox1" :class="showBreathe1?'breathe':''">
							<img src="../images/index/btn-p.png" alt="" style="width: 100%;">
						</div>
						<div class="content_img" v-show="showBox2" :class="showBreathe2?'breathe':''">
							<img src="../images/index/btn-lh.png" alt="" style="width: 100%;">
						</div>
						<div class="content_img" v-show="showBox3" :class="showBreathe3?'breathe':''">
							<img src="../images/index/btn-zc.png" alt="" style="width: 100%;">
						</div>
					</div>
				</div>
			</div>
			<div class="content_box" v-show="contentBox2">
				<div class="alert_box">
					<div class="alert_header">
						<img src="../images/index/ry-2.png" alt="" v-if="userlevel >= level" style="width: 100%;">
						<img src="../images/index/ry-3.png" alt="" v-else style="width: 100%;">
					</div>
					<div class="alert_content">
						<div class="content_img">
							<div class="content_img_box">
								<img src="../images/index/z-2.png"  v-if="userlevel >= level" alt="" style="width: 100%;">
								<img src="../images/index/z-1.png" v-else alt="" style="width: 100%;">
							</div>
							<div class="content_img_box">
								<img src="../images/index/z-3.png" v-if="userlevel >= level" alt="" style="width: 100%;">
								<img src="../images/index/z-4.png" v-else alt="" style="width: 100%;">
							</div>
						</div>
						<div class="content_img">
							<div class="content_img_btn" v-show="showBox4" :class="showBreathe4?'breathe1':''" @click="goHonour(1)">
								<img src="../images/index/gr-2.png" v-if="userlevel >= level" alt="" style="width: 100%;">
								<img src="../images/index/btn-gr-3.png" v-else alt="" style="width: 100%;">
							</div>
							<div class="content_img_btn" v-show="showBox5" :class="showBreathe5?'breathe1':''" @click="goHonour(2)">
								<img src="../images/index/btn-jt-2.png" v-if="userlevel >= level" alt="" style="width: 100%;">
								<img src="../images/index/jt-3.png" v-else alt="" style="width: 100%;">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index"

	export default {
		name: "InfoResult",
		components: {},
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				showBox1:false,
				showBox2:false,
				showBox3:false,
				showBreathe1:false,
				showBreathe2:false,
				showBreathe3:false,
				contentBox1:true,
				contentBox2:false,
				showBox4:false,
				showBox5:false,
				showBreathe4:false,
				showBreathe5:false,
				userlevel:0,
				level:12,
			};
		},
		created() {
			this.$parent.footer('infoResult',false);
		},
		watch: {
		},
		mounted() {
			this.userlevel = localStorage.getItem('login_userlevel');
			console.log(this.userlevel)
			this.start();
		},
		methods: {
			start(){
				setTimeout(() => {
					this.showBox1 = true;
					this.showBreathe1 = true;
				}, 1000);
				setTimeout(() => {
					this.showBreathe1 = false;
					this.showBox2 = true;
					this.showBreathe2 = true;
				}, 3000);
				setTimeout(() => {
					this.showBreathe2 = false;
					this.showBox3 = true;
					this.showBreathe3 = true;
				}, 6000);
				setTimeout(() => {
					this.showBreathe3 = false;
					this.contentBox1 = false;
					this.contentBox2 = true;
				}, 8000);
				setTimeout(() => {
					this.showBox4 = true;
					this.showBreathe4 = true;
				}, 9000);
				setTimeout(() => {
					this.showBreathe4 = false;
					this.showBox5 = true;
					this.showBreathe5 = true;
				}, 11000);
				setTimeout(() => {
					this.showBreathe5 = false;
				}, 13000);
			},
			goHonour(obj){
				this.$router.push('/infoHonour?type='+obj);
			},
		}
	};
</script>

<style lang="less" scoped>
	.backgroud_bg{
		position: absolute;
		z-index: 1;
		top: 0;
		left: 0;
	}
	.home_wrap {
		
	}
	.bengin_act {
	    position: absolute;
	    width: 100%;
	    z-index: 9;
	}
	.content_box {
	    position: absolute;
	    z-index: 10;
	    height: 100%;
		
		.alert_box {
		    position: relative;
		    top: 6.5rem;
		    width: 80%;
		    left: 10%;
			
			.alert_header {
			    position: relative;
			    width: 60%;
			    left: 20%;
			    margin-top: 0.25rem;
			}
		}
		.alert_content {
		    position: relative;
		    width: 72%;
		    left: 14%;
			
			.content_img {
			    margin-top: 0.3rem;
			}
			.breathe{
				animation: breathe 1.5s infinite;
			}
		}
		.breathe1{
			animation: breathe 1.5s infinite;
		}
		.content_img_box {
		    width: 90%;
		    position: relative;
		    left: 5%;
		    margin-bottom: 0.1rem;
		}
		.content_img_btn {
		    position: relative;
		    width: 60%;
		    left: 20%;
			margin-top: 0.1rem;
		}
	}
	
	@keyframes breathe {
		0%, 100% {
		  transform: scale(1);
		}
		50% {
		  transform: scale(0.9); /* 使div放大 */
		}
	}
</style>
